import { useModal } from "./CroModalContext";
import { CloseButton } from "react-bootstrap";

const CroModalCloseBtn = () => {
  const { hideModal } = useModal();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
      }}
    >
      <CloseButton
        onClick={() => hideModal()}
        style={{
          background: "none",
          border: "none",
          color: "#2D3748",
          fontSize: 24,
        }}
      />
    </div>
  );
};

export default CroModalCloseBtn;
